<template>
  <div class="result-list">
    <div class="top-part">
      <div class="products-counter">
        <span v-html="$t('results.counter.info', { loaded: productStore.modelCounts, total: productStore.products.length })"></span>
      </div>
      <div class="list-counter">
        <div class="list-counter-label"><span v-html="$t('results.counter.label')"></span></div>
        <div class="counter-selector">
          <select name="list-counter" id="list-counter" v-model="perPage">
            <option value="8">8</option>
            <option value="10">10</option>
            <option value="12">12</option>
            <option value="16">16</option>
          </select>
        </div>
      </div>
    </div>
    <div class="products-container" v-if="!loading">
      <template v-for="(model, index) in productStore.paginatedModels" :key="index">
        <productCard :model="model" />
      </template>
    </div>
    <div v-if="totalPages > 1" class="bottom-part">
      <div class="pagination-container">
        <pageList @changePage="changePage($event)" />
        <div class="page-counter">
            <span v-html="$t('results.pagination', { current: productStore.currentPage, total: totalPages })"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useProductsStore } from "@/stores/products"
import { computed, onBeforeMount, watch } from "vue"
import productCard from '@/components/ProductCard.vue'
import pageList from '@/components/pageList.vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from "@/stores"


export default {
  name: "ResultList",
  components: {
    productCard,
    pageList
  },
  setup () {
    const productStore = useProductsStore()
    const GlobalStore = useGlobalStore()
    const { perPage } = storeToRefs(productStore)
    const { loading } = storeToRefs(GlobalStore)
    const totalPages = computed(() => {
      return Math.max(1, Math.ceil(productStore.modelCounts / perPage.value))
    })

    watch(perPage, () => {
      productStore.currentPage = 1
      productStore.updatePaginatedModels()
    })

    function changePage (page) {
      GlobalStore.loading = true
      productStore.currentPage = page
      productStore.updatePaginatedModels()
      GlobalStore.loading = false
    }

    onBeforeMount(() => {
      productStore.currentPage = 1
    })
    return { productStore, perPage, productCard, totalPages, changePage, loading }
  },
}
</script>
